import React, { useState, useEffect } from "react"
import {
  Table,
  Input,
  Space,
  message,
  Tooltip,
  Dropdown,
  Tag,
  Menu,
  Form,
} from "antd"
import { EllipsisOutlined, EditOutlined, LockOutlined } from "@ant-design/icons"
import SvgIcon from "src/components/SvgIcon"
import UserManagement from "src/services/UserManagement"
import { UnlockOutlined } from "@ant-design/icons"
import TableCustom from "src/components/Table/CustomTable"
import IconBase from "src/components/IconBase"
import PopupAction from "src/components/PopupAction"
import Button from "src/components/MyButton/Button"
import CB1 from "src/components/Modal/CB1"
import ButtonCircle from "src/components/MyButton/ButtonCircle"
import STORAGE, { getStorage } from "src/lib/storage"
import ModalCreateAffiliateAcc from "./Modal/ModalCreateAffiliateAcc"
import AffiliateService from "src/services/AffiliateService"
import dayjs from "dayjs"

const AffiliateManager = () => {
  const [data, setData] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [searchValue, setSearchValue] = useState("")
  const [dataSelected, setDataSelected] = useState([])
  const [filter, setFilter] = useState({})
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [selectedStatus, setSelectedStatus] = useState(null)
  const [selectedId, setSelectedId] = useState(null)
  const [modalType, setModalType] = useState(null)
  const [form] = Form.useForm()
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  })
  const [summary, setSummary] = useState({})

  const handleEdit = record => {
    setEditingUser(record)
    setIsEditModalOpen(true)
  }

  const columns = [
    { title: "Mã giới thiệu", dataIndex: "code", align: "center" },
    {
      title: "Link giới thiệu",
      dataIndex: "click_url",
      key: "click_url",
      align: "center",
      render: click_url =>
        click_url ? (
          <a href={click_url} target="_blank" rel="noopener noreferrer">
            {click_url}
          </a>
        ) : (
          "-"
        ),
    },
    {
      title: "Họ và tên",
      dataIndex: "user",
      align: "center",
      render: user => user?.fullname,
    },
    {
      title: "Email",
      dataIndex: "user",
      align: "center",
      render: user => user?.email,
    },
    {
      title: "Số điện thoại",
      dataIndex: "user",
      align: "center",
      render: user => user?.phone,
    },
    {
      title: "Ngày đăng ký",
      dataIndex: "user",
      align: "center",
      render: user =>
        user?.date_created
          ? dayjs(user.date_created).format("DD-MM-YYYY")
          : "--",
    },
    // {
    //   title: "Trạng thái tài khoản",
    //   align: "center",
    //   dataIndex: "status",
    //   render: (text, record) => (
    //     <span
    //       style={{
    //         color: record.is_locked === 0 ? "green" : "red",
    //         fontWeight: 600,
    //       }}
    //     >
    //       {record.is_locked === 0 ? "Đang hoạt động" : "Đã bị khóa"}
    //     </span>
    //   ),
    // },
    { title: "Lượt Click", dataIndex: "total_clicks", align: "center" },
    // { title: "Số đơn hàng", dataIndex: "total_order", align: "center" },
    // { title: "Tổng doanh thu", dataIndex: "", align: "center" },
    // { title: "Hoa hồng", dataIndex: "", align: "center" },
    // {
    //   title: <Tooltip title={"Hành động"}>_</Tooltip>,
    //   dataIndex: "action",
    //   key: "action",
    //   align: "center",
    //   render: (_, record) => {
    //     return (
    //       <PopupAction>
    //         {/* {permissions.includes("users.lock") &&
    //         permissions.includes("users.unlock") ? (
    //           <div
    //             key={record.is_locked === 1 ? "unlock" : "lock"}
    //             onClick={() =>
    //               record.is_locked === 1
    //                 ? handleUnlockAccount(record)
    //                 : handleLockAccount(record)
    //             }
    //           >
    //             {record.is_locked === 1 ? (
    //               <UnlockOutlined style={{ color: "#1E90FF" }} />
    //             ) : (
    //               <LockOutlined style={{ color: "#1E90FF" }} />
    //             )}
    //             {record.is_locked === 1 ? "Mở tài khoản" : "Khóa tài khoản"}
    //           </div>
    //         ) : (
    //           <React.Fragment />
    //         )} */}

    //         {permissions.includes("users.update") ? (
    //           <div onClick={() => handleEdit(record)}>
    //             <IconBase name="edit" />
    //             <span>Sửa</span>
    //           </div>
    //         ) : (
    //           <React.Fragment />
    //         )}

    //         <div onClick={() => handleViewDetail(record)}>
    //           <IconBase name="eye" />
    //           <span>Xem chi tiết</span>
    //         </div>
    //       </PopupAction>
    //     )
    //   },
    // },
  ]

  const handleLockAccount = async record => {
    try {
      await UserManagement.LockUser({ ids: [record.id] })
      message.success("Khóa tài khoản thành công!")
      fetchUsers()
    } catch (error) {
      console.error("Lỗi khi khóa tài khoản:", error)
      message.error("Khóa tài khoản thất bại!")
    }
  }

  const handleUnlockAccount = async record => {
    try {
      await UserManagement.UnlockUser({ ids: [record.id] })
      message.success("Mở tài khoản thành công!")
      fetchUsers()
    } catch (error) {
      console.error("Lỗi khi mở tài khoản:", error)
      message.error("Mở tài khoản thất bại!")
    }
  }
  const handleMultiUnlock = async () => {
    const ids = dataSelected.map(item => item.id)
    try {
      await UserManagement.UnlockUser({ ids })
      message.success("Mở khóa tài khoản thành công!")
      fetchUsers()
      setDataSelected([])
      setSelectedRowKeys([])
      setSelectedStatus(null)
    } catch (error) {
      console.error("Lỗi khi mở khóa tài khoản:", error)
      message.error("Mở khóa tài khoản thất bại!")
    }
  }

  const handleMultiLock = async () => {
    const ids = dataSelected.map(item => item.id)
    try {
      await UserManagement.LockUser({ ids })
      message.success("Khóa tài khoản thành công!")
      fetchUsers()
      setDataSelected([])
      setSelectedRowKeys([])
      setSelectedStatus(null)
    } catch (error) {
      console.error("Lỗi khi khóa tài khoản:", error)
      message.error("Khóa tài khoản thất bại!")
    }
  }

  const fetchUsers = async (page, per_page, filter, keyword = "") => {
    try {
      const response = await AffiliateService.listAffiliate({
        page,
        per_page,
        filter: {
          ...filter,
        },
        keyword, // Truyền từ khóa tìm kiếm vào API
      })

      const users = response?.success?.data || []
      const total = response?.success?.total || users.length
      const active = response?.success?.status?.active || 0
      const lock = response?.success?.status?.lock || 0

      // const userList = users.map((user, index) => ({
      // }))

      setData(users)
      setPagination(prev => ({
        ...prev,
        current: page,
        total, // Cập nhật lại tổng số bản ghi từ API
      }))
      setSummary({
        totalAccounts: total,
        activeAccounts: active,
        lockedAccounts: lock,
      })
    } catch (error) {
      console.error("Lỗi khi lấy danh sách người dùng affiliate:", error)
      message.error("Không thể lấy danh sách người dùng affiliate")
    }
  }

  useEffect(() => {
    fetchUsers(pagination.current, pagination.pageSize, filter, searchValue)
  }, [pagination.current, pagination.pageSize])
  useEffect(() => {
    console.log(pagination)
    if (pagination.current !== 1) {
      setPagination(prev => ({
        ...prev,
        current: 1,
      }))
    } else {
      if (pagination.total !== undefined) {
        fetchUsers(pagination.current, pagination.pageSize, filter, searchValue)
      }
    }
  }, [filter, searchValue])
  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys, selectedRows) => {
      setSelectedRowKeys(newSelectedRowKeys)
      setDataSelected(selectedRows)
      if (selectedRows.length > 0) {
        setSelectedStatus(selectedRows[0].status)
      } else {
        setSelectedStatus(null)
      }
    },
    getCheckboxProps: record => ({
      disabled: selectedStatus !== null && record.status !== selectedStatus,
    }),
  }
  const handleSearch = value => {
    setSearchValue(value)
    fetchUsers(pagination.current, pagination.pageSize)
  }

  const [isEditModalOpen, setIsEditModalOpen] = useState(false)
  const [editingUser, setEditingUser] = useState({})

  const handleTableChange = newPagination => {
    setPagination({
      ...pagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    })
  }
  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  const handleViewDetail = async record => {
    // console.log(record);
    setSelectedId(record.id)
    setModalType("view")
  }
  const [shownError, setShownError] = useState(false)
  const permissions = localStorage.getItem(STORAGE.PERMISSIONS) || ""

  const hasPermission = permissions.includes("users")

  useEffect(() => {
    if (!hasPermission && !shownError) {
      message.error("Không có quyền truy cập")
      setShownError(true)
    }
  }, [!hasPermission, shownError])

  if (!hasPermission) {
    return null // hoặc <Navigate to="/not-authorized" />
  }
  return (
    <div>
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: 30,
          marginBottom: 16,
          flexWrap: "wrap",
          gap: 8,
        }}
      >
        <h3
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            color: "#005F90",
            margin: 0,
          }}
        >
          QUẢN LÝ THÔNG TIN AFFILIATE
        </h3>
        {/* <Button btnType="primary1" size="large" onClick={handleOpenModal}>
          Tạo mới
        </Button> */}
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 10,
          marginBottom: 16,
        }}
      >
        {/* Các nút hành động */}
        <div style={{ display: "flex", gap: 10 }}>
          {!!dataSelected.length && (
            <>
              <ButtonCircle
                title="Mở tài khoản đã chọn"
                iconName="unlock"
                onClick={() =>
                  CB1({
                    title: `Bạn có chắc chắn muốn mở tài khoản <strong>${dataSelected.length}</strong> bản ghi không?`,
                    icon: "unlock",
                    okText: "Đồng ý",
                    onOk: async close => {
                      await handleMultiUnlock()
                      close()
                    },
                  })
                }
              />

              <ButtonCircle
                title="Khóa tài khoản đã chọn"
                iconName="lock"
                onClick={() =>
                  CB1({
                    title: `Bạn có chắc chắn muốn khóa tài khoản <strong>${dataSelected.length}</strong> bản ghi không?`,
                    icon: "lock",
                    okText: "Đồng ý",
                    onOk: async close => {
                      await handleMultiLock()
                      close()
                    },
                  })
                }
              />
            </>
          )}
        </div>
        {/* <FilterAdmin setFilter={setFilter} /> */}
        {/* Ô tìm kiếm */}
        {/* <div style={{ marginLeft: "auto" }}>
          <Space>
            <InputSearchStyle>
              <Input
                className="custom-input"
                maxLength={50}
                placeholder="Họ và tên"
                // value={searchValue}
                // onChange={e => setSearchValue(e.target.value)}
                onPressEnter={e => setSearchValue(e.target.value)}
              />
              <div className="custom-icon-search">
                <SvgIcon
                  name="searchStatistic"
                  // onClick={() => handleSearch("")}
                />
              </div>
            </InputSearchStyle>
          </Space>
        </div> */}
      </div>
      <div style={{ display: "flex", flexDirection: "row", margin: "10px 0" }}>
        <div style={{ padding: "0 5px", color: "#007BFF" }}>
          <strong>Tổng số tài khoản: {summary.totalAccounts}</strong>
        </div>
        {/* <div style={{ padding: "0 5px", color: "#28A745" }}>
          <strong>Đang hoạt động: {summary.activeAccounts}</strong>
        </div>
        <div style={{ padding: "0 5px", color: "#FF0000" }}>
          <strong>Đã bị khóa: {summary.lockedAccounts}</strong>
        </div> */}
      </div>
      {/* Bảng */}
      <TableCustom
        showPagination={true}
        // rowSelection={{
        //   type: "checkbox",
        //   ...rowSelection,
        // }}
        isPrimary
        columns={columns}
        dataSource={data}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
        }}
        onChange={handleTableChange}
        bordered
        scroll={{ x: "max-content" }}
      />
      {/* {modalType === "view" && (
        <ViewDetailModal
          open={true}
          onCancel={() => setModalType(null)}
          form={form}
          recordId={selectedId}
        />
      )} */}
      {/* <ModalCreateAffiliateAcc
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onOk={() => {
          form.validateFields().then(values => {
            console.log("Form values:", values)
            // Gọi API để tạo tài khoản affiliate
            // Sau khi thành công, đóng modal và làm mới danh sách
            setIsModalOpen(false)
          })
        }}
      /> */}
    </div>
  )
}
export default AffiliateManager
